import SecureStorage from "secure-web-storage";

import SHA256 from "crypto-js/sha256";
import AES from "crypto-js/aes";
import enc from "crypto-js/enc-utf8";

const getHashManager = (secret_key = process.env.REACT_APP_SECRET_KEY_DEFAULT) => {
  return {
    hash: function hash(key) {
      key = SHA256(key, secret_key);
      return key.toString();
    },
    encrypt: function encrypt(data) {
      data = AES.encrypt(data, secret_key);
      data = data.toString();
      return data;
    },
    decrypt: function decrypt(data) {
      data = AES.decrypt(data, secret_key);
      data = data.toString(enc);
      return data;
    },
  };
};

export const mySecureStorage = new SecureStorage(
  localStorage,
  getHashManager(process.env.REACT_APP_SECRET_KEY_LOCAL_STORAGE)
);

export default mySecureStorage;
